import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";
import Brand from "./Brand";
import LanguageSwitch from "./LanguageSwitch";
import { Hourglass, LogOut } from "lucide-react";

export default function WaitingApproval() {
  const { user, logout } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const out = async () => { await logout(); navigate("/login"); };
  return (
    <div className="min-h-screen flex items-center justify-center p-6" data-testid="waiting-approval-screen">
      <div className="surface-card w-full max-w-md rounded-2xl border border-border bg-card p-8 space-y-5 text-center">
        <div className="flex items-center justify-between"><Brand size="sm" /><LanguageSwitch /></div>
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-amber-100 text-amber-700">
          <Hourglass className="h-7 w-7" />
        </div>
        <h1 className="font-heading text-2xl font-semibold text-foreground">{t("pending.title")}</h1>
        <p className="text-sm text-muted-foreground">{t("pending.text")}</p>
        <div className="text-sm font-medium text-foreground" data-testid="waiting-user-name">{user?.name}</div>
        <button onClick={out} data-testid="waiting-logout-btn" className="inline-flex items-center gap-2 rounded-lg border border-border px-4 py-2 text-sm font-medium hover:bg-secondary">
          <LogOut className="h-4 w-4" /> {t("pending.logout")}
        </button>
      </div>
    </div>
  );
}
